import type { NavigationTile } from "app/pages/digital-marketing/home-pages/constants";

export const navigationTiles: NavigationTile[] = [
    {
        id: "KeywordAnalysis",
        title: "acquisition.homepage.keywords.analysis.pages.title",
        subTitle: "acquisition.homepage.keywords.analysis.pages.subtitle",
        iconName: "affiliates-keyword",
        navigationState: "organicsearch_keywordanalysis_home",
    },
];
